import { useQuery } from '@tanstack/react-query';

import getHostList from 'Api/brief-live/getHostList';

import getHostListRequest from './model/request/getHostListRequest';
import getHostListResponse from './model/response/getHostListResponse';

const useGetHostList = ({ queryParams, isEnabled = false }) => {
  return useQuery({
    queryKey: ['special-event-host-list', queryParams],
    queryFn: async () => {
      const queries = getHostListRequest({ queryParams });

      const response = await getHostList(queries);

      return getHostListResponse(response);
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled: isEnabled,
  });
};

export default useGetHostList;
